module.exports = __webpack_public_path__ + "static/media/component2.f92423fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component2.png
// module id = 2406
// module chunks = 0